///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/presenters/number/defaults"/>
export function get() {
    return {
        template: "presenters-number-default",
        resolution: 0,
        trimZeros: false,
        roundDecimal: 'midpoint', //round, floor, ceil
        notLocalized: false
    };
}